import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { type SiteEntity, type UpdateSiteRequest } from '@common/types/site.type';
import { type SitePageEntity } from '@common/types/site-page.type';
import { type Template } from '@common/types/template.type';
import { type FileEditType } from '@common/types/editor-file.type';

type NavigateTo = { pageId?: string; siteId?: string; isNew?: boolean };

export const SiteActions = createActionGroup({
    source: 'Site',
    events: {
        'Load site success': props<{ site: SiteEntity; currentPage: SitePageEntity }>(),
        'Load site failure': props<{ error: string }>(),
        'Load template success': props<{ template: Template }>(),
        'Set new site data': props<{ name?: string; domain: string }>(),
        'Save site': props<{
            exit?: boolean;
            publish?: boolean;
            navigateTo?: NavigateTo;
            skipContentChange?: boolean;
            capturedPageId: string | number;
        }>(),
        'Save site request': props<{
            exit?: boolean;
            publish: boolean;
            navigateTo?: NavigateTo;
            skipContentChange?: boolean;
            isRedirectTabClose?: boolean;
            capturedPageId: string | number;
        }>(),
        'Save site success': props<{ site: SiteEntity }>(),
        'Save site failure': props<{ error: string }>(),
        /** The save never reached the server — the page stays unsaved and is retried. */
        'Save site offline': emptyProps(),
        'Create site request': props<{
            exit?: boolean;
            publish?: boolean;
            navigateTo?: NavigateTo;
            templateId: string | undefined;
            isRedirectTabClose?: boolean;
        }>(),
        'Create site success': props<{ site: SiteEntity }>(),
        'Update site request': props<{ siteId: number; data: UpdateSiteRequest; updateDomains?: boolean }>(),
        'Update site success': props<{ site: SiteEntity }>(),
        'Update site failure': props<{ error: string }>(),
        'Update site': props<{ site: SiteEntity }>(),
        'Update admin site template request': props<{ exit?: boolean }>(),
        'Preview site request': props<{ content: string }>(),
        'Preview site success': props<{ content: string }>(),
        'Preview site failure': props<{ error: string }>(),
        'Navigate template site page': props<{ templateId: string; siteId: string; pageId: string }>(),
        'Upload image': props<{ data: FileEditType }>(),
        'Only upload image': props<{ data: any }>(),
        'Upload image success': emptyProps(),
        'Upload image failure': props<{ error: any }>(),
        'Toggle saving': props<{ saving: boolean }>(),
        'Resize image': props<{ url: string; path: string }>(),
    },
});

export default SiteActions;
